module.exports = __webpack_public_path__ + "static/img/buzzer3v-1.02d3c76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/buzzer3v-1.svg
// module id = UJes
// module chunks = 0